import React from "react";
import { getData } from "app/data";
import MerchantService from "components/MerchantService";
import CommonUseCases from "components/CommonUseCases";
import WaitingFor from "components/Banner/WaitingFor";
import "./CloverMini.css";
// import GreenBanner from "components/Banner/GreenBanner";
import ServiceGreenBanner from "components/Banner/ServiceGreenBanner"; 
import ContentsTwoColumn from "components/MerchantService/ContentsTwoColumn";
import HeaderBackground from "components/BackGround/HeaderBackground";
import { ReactComponent as LeftBox } from "images/background/left-box-graphic.svg";
import { ReactComponent as RightBox } from "images/background/right-box-graphic.svg";

// modified code
import CloverMiniPricingTable from "components/Banner/CloverMiniPricingTable";
// modified code

import { useSmoothScroll } from 'components/Main/pages/MerchantService/useSmoothScroll.js';
export default function Index() {
    const { myRef, clickHandle } = useSmoothScroll();
    const pos_data = getData("posDeviceData")[1];
    const contents = getData("cloverMiniData");

    return (
        <div className="clover-mini-page">
            <HeaderBackground />
            <MerchantService data={pos_data} header={true} clickHandle={clickHandle} />

            <div className="background">

                <LeftBox className="left-box-bg" />
                <RightBox className="right-box-bg" />
                <LeftBox className="left2-box-bg" />
                <RightBox className="right2-box-bg" />
                {/* <GreenBanner
                    leftText={contents.banner_left_title}
                    rightText={contents.banner_right_contents}
                /> */}
                <ServiceGreenBanner
                    leftText={contents.banner_left_title}
                    rightText={contents.banner_right_contents}
                />
                <div ref={myRef} />
                <CloverMiniPricingTable/>
                <ContentsTwoColumn data={contents.features} posName="cloverMini" multipleRow={true} />
            </div>
            <CommonUseCases data="posDevicesData" />
            <WaitingFor />
        </div>
    );
}
